import { useState } from "react";
import { Form } from "react-bootstrap";
import styles from "./QuestionProfiles.module.css";
import YuJaButton from "../standardization/YuJaButton";
import {YuJaTextBox} from "../standardization/YuJaTextBox";
import {
    QUESTION_BANK_SEARCH_BAR_PLACEHOLDER, SEARCH_TEXT,
    TEXTBOX
} from '../../utils/constants';

export default function QuestionBankSearch({buttonStyle, handleSubmit }) {
    const [keyword, setKeyword] = useState("");

    const clickSearch = () => {
        handleSubmit({ keyword: keyword});
    }

    const enterKeyup = (e) => {
        if (e.key === 'Enter') {
            clickSearch();
        }
    }

    return (
        <div className={styles.searchBox} style={{margin: "0px"}}>
            <Form className={styles.searchBoxForm} onSubmit={e => e.preventDefault()}>
                <YuJaTextBox
                    containerStyle={{marginRight: 15}}
                    placeholder={QUESTION_BANK_SEARCH_BAR_PLACEHOLDER}
                    onChange={e => setKeyword(e.target.value)}
                    onKeyUp={enterKeyup}
                    value={keyword}
                >
                </YuJaTextBox>

                <YuJaButton style={buttonStyle} role={TEXTBOX} onClick={clickSearch}>{SEARCH_TEXT}</YuJaButton>
            </Form>
        </div>
    );
}